module.exports = __webpack_public_path__ + "img/poster-2.433dbd38.jpg";